import { render, staticRenderFns } from "./TrainingRegulationsDetails.vue?vue&type=template&id=08f5187d&"
import script from "./TrainingRegulationsDetails.vue?vue&type=script&lang=js&"
export * from "./TrainingRegulationsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports